module.exports = __webpack_public_path__ + "img/audioStop.f116d9e3.svg";